// extracted by mini-css-extract-plugin
export var betaBadge = "NZyEkPcK2IB0frLveRpH";
export var mobileMenu = "jikYHbSpisS_vblVPIW0";
export var mobileMenuBackdrop = "KVhxXro7BvVFthFxkrG6";
export var mobileMenuLogo = "qftIOhTObaBJEokkWkA3";
export var mobileMenuLogoContainer = "E1Nc6fhMSQJtYt7lbQd_";
export var mobileMenuSidebar = "gWD0qwjf9NIxyMvrqj3p";
export var mobileMenu_open = "tymrOApl5Jrh_HXrN5PM";